import { render, staticRenderFns } from "./xgJNJPersonal.vue?vue&type=template&id=860ad47e&scoped=true&"
import script from "./xgJNJPersonal.vue?vue&type=script&lang=js&"
export * from "./xgJNJPersonal.vue?vue&type=script&lang=js&"
import style0 from "./xgJNJPersonal.vue?vue&type=style&index=0&id=860ad47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860ad47e",
  null
  
)

export default component.exports